import { produce } from "immer";
import {
  GET_LOCATION_RULES,
  GET_LOCATION_RULES_SUCCESS,
  GET_LOCATION_RULES_FAILURE,
  CREATE_LOCATION_RULE,
  CREATE_LOCATION_RULE_SUCCESS,
  CREATE_LOCATION_RULE_FAILURE,
  UPDATE_LOCATION_RULE,
  UPDATE_LOCATION_RULE_SUCCESS,
  UPDATE_LOCATION_RULE_FAILURE,
  DELETE_LOCATION_RULE,
  DELETE_LOCATION_RULE_SUCCESS,
  DELETE_LOCATION_RULE_FAILURE,
  RESCRAPE_LOCATION_RULE,
  RESCRAPE_LOCATION_RULE_SUCCESS,
  RESCRAPE_LOCATION_RULE_FAILURE,
} from "./constants";

export const initialState = {
  rules: [],
  isFetching: false,
  isSubmitting: false,
  isDeleting: false,
  isRescraping: false,
};

const LocationRuleReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case GET_LOCATION_RULES:
        draft.isFetching = true;
        break;
      case GET_LOCATION_RULES_SUCCESS:
        draft.isFetching = false;
        draft.rules = action.payload?.data ?? action.payload ?? [];
        break;
      case GET_LOCATION_RULES_FAILURE:
        draft.isFetching = false;
        draft.rules = [];
        break;

      case CREATE_LOCATION_RULE:
        draft.isSubmitting = true;
        break;
      case CREATE_LOCATION_RULE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case CREATE_LOCATION_RULE_FAILURE:
        draft.isSubmitting = false;
        break;

      case UPDATE_LOCATION_RULE:
        draft.isSubmitting = true;
        break;
      case UPDATE_LOCATION_RULE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case UPDATE_LOCATION_RULE_FAILURE:
        draft.isSubmitting = false;
        break;

      case DELETE_LOCATION_RULE:
        draft.isDeleting = true;
        break;
      case DELETE_LOCATION_RULE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_LOCATION_RULE_FAILURE:
        draft.isDeleting = false;
        break;

      case RESCRAPE_LOCATION_RULE:
        draft.isRescraping = true;
        break;
      case RESCRAPE_LOCATION_RULE_SUCCESS:
        draft.isRescraping = false;
        break;
      case RESCRAPE_LOCATION_RULE_FAILURE:
        draft.isRescraping = false;
        break;

      default:
        return state;
    }
  });

export default LocationRuleReducer;
